// IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1)
// Единый рендер круга в ячейке-дате отчёта REPORT2 (все режимы вида ячеек — src/utils/cellViews/*). Чистые функции (без Vue и DOM) — tests/unit/cellRing.test.mjs.
// Вход: слои layers [{ key, title, value, color, tone: 'solid' | 'light-N' }], шкала scale { max, kind: 'qty' | 'pct' | 'money', unit },
// сигналы signals [{ kind: 'uncovered' | 'over-100' | 'excess' | 'over-max' | 'grown' | 'manual', color? }], размер size { cellW, cellH }.
// Выход cellRing_build: { bg (conic-gradient или сплошной цвет), diameter (px), dMax, ring ({ kind, color, width } | null), only (узкая колонка — только круг), value, share, over }.
// Площадь круга ∝ доля значения от максимума группы шкалы (диаметр ∝ √доли), минимум 6 px, максимум min(cellH, cellW) − 4.
// Проценты: полный круг = 100 %, больше — сигнал over-100 (красное кольцо); значение больше max группы — тоже over-100.
// Выключатель fe.ux.cellViewRing (по умолчанию ВКЛ): ВЫКЛ — прежний вид пирога (постоянный диаметр 13 px, без кольца)

import { pieGap_stops, pieGap_deg } from '@/utils/pieGaps'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p211 контрастні кольори категорій і білий роздільник між секторами кіл)
import { GRID_TALL_ROW_H } from '@/utils/gridRows'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 діаграми в клітинках — на всю висоту рядка, компактні й високі)

export const CELL_RING_FLAG = 'fe.ux.cellViewRing'
export const CELL_RING_MIN_D = 6
export const CELL_RING_LEGACY_D = 13   // диаметр прежнего пирога status_pie (флаг fe.ux.cellViewRing ВЫКЛ)

// цвета колец сигналов; порядок CELL_RING_PRIORITY — кто побеждает, если сигналов несколько
export const CELL_RING_COLORS = {
    uncovered: '#e53935', 'over-100': '#e53935', excess: '#0d47a1', 'over-max': '#1e88e5', grown: '#43a047',
}
export const CELL_RING_PRIORITY = ['uncovered', 'over-100', 'excess', 'over-max', 'grown']
export const CELL_RING_WIDTH = 2

const str = (v) => (v === null || v === undefined ? '' : String(v)).trim()
const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0 }

export function cellRing_flagOn(setting) {   // чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(CELL_RING_FLAG, true) !== false : true } catch (e) { return true }
}

// ---- шкала ----------------------------------------------------------------------------------------------------------------------------
// вид шкалы по формату ячейки / строки (wijmo 'p0' — доли, литерал '%' — проценты числом; 'c2' / символ валюты — деньги) и measure_type строки
const MONEY_RE = /[$€₴£¥₽]/
export function cellRing_scaleKind(format, measureType) {
    const f = str(format), mt = str(measureType)
    if (/^p\d*$/i.test(f) || f.includes('%') || mt.includes('%')) return 'pct'
    if (/^c\d*$/i.test(f) || MONEY_RE.test(f) || MONEY_RE.test(mt)) return 'money'
    return 'qty'
}
// единица полного круга процентов: wijmo 'pN' — значения долями (1 = 100 %), иначе — процентами числом (100)
export function cellRing_pctUnit(format) {
    return /^p\d*$/i.test(str(format)) ? 1 : 100
}
// группа шкалы ячейки: признак строки раскладки scale_group (_DLRow.scale_group), иначе вид по формату — { group, kind, unit }
export function cellRing_scaleGroup(scaleGroup, format, measureType) {
    const kind = cellRing_scaleKind(format, measureType)
    const g = str(scaleGroup)
    return { group: g || kind, kind, unit: kind === 'pct' ? cellRing_pctUnit(format) : 0 }
}
// максимумы групп по строкам ответа: rows — массив строк, cellsOf(row) → [{ group, kind, unit, value }] (ячейки-даты строки).
// → { [group]: { max, kind, unit } }; max — максимум |значения|. Кеш — снаружи (один раз на ответ)
export function cellRing_scale(rows, cellsOf) {
    const out = {}
    if (!Array.isArray(rows) || typeof cellsOf !== 'function') return out
    for (const r of rows) {
        let cells
        try { cells = cellsOf(r) } catch (e) { cells = null }
        if (!cells) continue
        for (const c of cells) {
            if (!c) continue
            const g = str(c.group) || 'qty'
            const v = Math.abs(num(c.value))
            const s = out[g] || (out[g] = { max: 0, kind: c.kind || 'qty', unit: c.unit || 0 })
            if (v > s.max) s.max = v
        }
    }
    return out
}

// ---- диаметр --------------------------------------------------------------------------------------------------------------------------
// максимальный диаметр в ячейке: min(cellH, cellW) − 4 (не меньше 0)
export function cellRing_maxDiameter(size) {
    const w = num(size && size.cellW), h = num(size && size.cellH)
    const m = Math.min(w > 0 ? w : h, h > 0 ? h : w)
    return Math.max(0, Math.round(m) - 4)
}
// → { diameter, dMax, share, over }: share — доля от полного круга (без обрезки), over — значение больше полного круга (pct > 100 %, иначе > max)
export function cellRing_diameter(value, scale, size) {
    const dMax = cellRing_maxDiameter(size)
    const v = Math.abs(num(value))
    const kind = (scale && scale.kind) || 'qty'
    let full = kind === 'pct' ? (num(scale && scale.unit) > 0 ? num(scale.unit) : 100) : num(scale && scale.max)
    if (!(full > 0)) full = v   // шкалы нет (max 0 / не посчитан) — полный круг
    if (!(v > 0) || !(dMax > 0)) return { diameter: 0, dMax, share: 0, over: false }
    const share = v / full
    const eps = 1e-9
    const over = share > 1 + eps
    let d = dMax * Math.sqrt(Math.min(1, share))
    if (d < CELL_RING_MIN_D) d = Math.min(CELL_RING_MIN_D, dMax)
    return { diameter: Math.round(d), dMax, share, over }
}

// ---- p190: диаграмма на всю высоту строки -------------------------------------------------------------------------------------------
// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 діаграми в клітинках — на всю висоту рядка, компактні й високі)
// Выключатель fe.ux.cellChartFillRow (дефолт ВКЛ, §8): круг вида ячеек — постоянного диаметра на всю высоту строки (состав — секторами, величина — числом
// справа), столбики — на всю высоту строки (каждая ячейка в своём масштабе: самый высокий слой = полный столбик; проценты — по-прежнему 100 % = полный).
// ВЫКЛ — прежние размеры (площадь круга ∝ значению в шкале группы, min 6 px). Размер ОДИН во всей таблице (не зависит от значения, ширины колонки и числа):
// разный диаметр в соседних ячейках читался как разная величина (вопрос Игоря 02.11: «19 000» в Грудні и Лютому — разные круги, т.к. Лютий уже).
// Узкая колонка «только круг» (число в подсказке) — круг не шире ячейки − 4.
// Геометрия: внутренняя высота ячейки = высота строки − 1 (нижняя рамка wijmo); поля сверху/снизу — 1 px в компактных строках, 3 px в высоких
// (высота ≥ GRID_TALL_ROW_H); внутренняя высота − диаметр чётна → круг по центру попадает в целые пиксели (без размытия).
export const CELL_CHART_FILL_FLAG = 'fe.ux.cellChartFillRow'
export const CELL_CHART_PAD_COMPACT = 1
export const CELL_CHART_PAD_TALL = 3
export function cellChart_fillOn(setting) {   // чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(CELL_CHART_FILL_FLAG, true) !== false : true } catch (e) { return true }
}
// высота строки → высота области диаграммы (внутренняя высота − поля); 0 — высоты нет
export function cellChart_fillHeight(rowH) {
    const h = Math.round(num(rowH))
    if (!(h > 2)) return 0
    const pad = h >= GRID_TALL_ROW_H ? CELL_CHART_PAD_TALL : CELL_CHART_PAD_COMPACT
    return Math.max(0, h - 1 - 2 * pad)
}
// диаметр круга на всю высоту строки — один для всех ячеек таблицы; чётность как у внутренней высоты (центр в целых пикселях); не меньше прежнего dOld.
// size { cellW, cellH }; only — узкая колонка (только круг, число в подсказке): не шире ячейки − 4
export function cellChart_fillDiameter(size, dOld = 0, only = false) {
    const old = Math.max(0, Math.round(num(dOld)))
    let d = cellChart_fillHeight(size && size.cellH)
    if (!(d > 0)) return old
    const hIn = Math.round(num(size && size.cellH)) - 1
    const cellW = num(size && size.cellW)
    if (only && cellW > 0 && cellW - 4 < d) d = Math.floor(cellW - 4)
    if (d > 0 && (hIn - d) % 2 !== 0) d -= 1
    return Math.max(d, old)
}
// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 — розмір кола від максимуму рядка, 60…100 %)
// диаметр по значению от максимума СТРОКИ (видимые колонки-даты строки той же группы шкалы): d = dFill × (0.6 + 0.4 × √(v / rowMax)) — от 60 % до 100 %
// высоты области; равные значения строки — равные круги, большее — не меньше (монотонно). Нет rowMax (0) — полный dFill. Чётность как у cellChart_fillDiameter
export const CELL_CHART_ROW_MIN = 0.6
export function cellChart_rowDiameter(value, rowMax, dFill, cellH) {
    const D = Math.max(0, Math.round(num(dFill)))
    const M = Math.abs(num(rowMax)), v = Math.abs(num(value))
    if (!(D > 0)) return 0
    const k = M > 0 ? CELL_CHART_ROW_MIN + (1 - CELL_CHART_ROW_MIN) * Math.sqrt(Math.min(1, v / M)) : 1
    let d = Math.round(D * k)
    const hIn = Math.round(num(cellH)) - 1
    if (hIn > 0 && (hIn - d) % 2 !== 0) d -= 1
    return Math.max(Math.min(d, D), Math.min(D, 2))
}
// толщина кольца сигнала ∝ диаметру (d / 10, шаг 0.5 px), не тоньше 1.5 px
export function cellChart_ringWidth(d) {
    return Math.max(1.5, Math.round(num(d) / 10 * 2) / 2)
}

// ---- заливка --------------------------------------------------------------------------------------------------------------------------
// осветление цвета ступенью tone 'light-N' (N = 1…5: смешение с белым по 15 % на ступень); 'solid' / неизвестный тон / не #hex — без изменений
export function cellRing_tone(color, tone) {
    const m = /^light-(\d+)$/.exec(str(tone))
    const c = str(color)
    const hx = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(c)
    if (!m || !hx) return c
    const n = Math.max(0, Math.min(5, Number(m[1])))
    if (!n) return c
    let h = hx[1]
    if (h.length === 3) h = h.split('').map(x => x + x).join('')
    const k = n * 0.15
    const ch = [0, 2, 4].map(i => parseInt(h.slice(i, i + 2), 16)).map(x => Math.round(x + (255 - x) * k))
    return '#' + ch.map(x => x.toString(16).padStart(2, '0')).join('')
}
// слои → фон круга: несколько цветов — conic-gradient (доли по положительным значениям, соседние одного цвета склеиваются), один — сплошной цвет; нет — ''
export function cellRing_conic(layers, opts) {   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p211 контрастні кольори категорій і білий роздільник між секторами кіл): opts { gaps, diameter } — белые разделители секторов (pieGaps.js)
    const parts = []
    for (const l of (Array.isArray(layers) ? layers : [])) {
        const v = num(l && l.value)
        if (!(v > 0)) continue
        const color = cellRing_tone(l.color || '#9e9e9e', l.tone)
        const last = parts[parts.length - 1]
        if (last && last.color === color) last.v += v
        else parts.push({ color, v })
    }
    if (!parts.length) return ''
    if (parts.length === 1) return parts[0].color
    const tot = parts.reduce((s, p) => s + p.v, 0)
    const gd = opts && opts.gaps ? pieGap_deg(opts.diameter) : 0   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p211 контрастні кольори категорій і білий роздільник між секторами кіл)
    if (gd > 0) return `conic-gradient(${pieGap_stops(parts.map(p => ({ color: p.color, share: p.v })), gd).join(', ')})`   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p211 контрастні кольори категорій і білий роздільник між секторами кіл): зазоры — стопы в градусах
    let acc = 0
    const stops = parts.map((p, i) => {
        const a = acc
        acc += p.v
        const b = i === parts.length - 1 ? 100 : Math.round((acc / tot) * 10000) / 100
        return `${p.color} ${Math.round((a / tot) * 10000) / 100}% ${b}%`
    })
    return `conic-gradient(${stops.join(', ')})`
}

// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p198 вид «Сигнали» — проблемні сигнали шарами кола, фон лише від lead time / циклу поповнення / зон запасу)
// слои → «слоёный» круг: концентрические кольца равной толщины, первый слой — внешнее кольцо, последний — сердцевина; один слой — сплошной цвет; нет — ''
export function cellRing_concentric(layers) {
    const cs = []
    for (const l of (Array.isArray(layers) ? layers : [])) {
        if (!(num(l && l.value) > 0)) continue
        const c = cellRing_tone(l.color || '#9e9e9e', l.tone)
        if (cs[cs.length - 1] !== c) cs.push(c)
    }
    if (!cs.length) return ''
    if (cs.length === 1) return cs[0]
    const n = cs.length
    const r = (i) => Math.round((i / n) * 10000) / 100
    const stops = cs.slice().reverse().map((c, i) => `${c} ${r(i)}% ${i === n - 1 ? 100 : r(i + 1)}%`)
    return `radial-gradient(circle closest-side, ${stops.join(', ')})`
}

// ---- кольцо ---------------------------------------------------------------------------------------------------------------------------
// сигналы → кольцо { kind, color, width } победителя по CELL_RING_PRIORITY (manual и прочие — не кольцо, а маркер); нет — null
export function cellRing_ring(signals) {
    const by = new Map()
    for (const s of (Array.isArray(signals) ? signals : [])) {
        const k = s && str(s.kind)
        if (k && !by.has(k)) by.set(k, s)
    }
    for (const k of CELL_RING_PRIORITY) {
        const s = by.get(k)
        if (s) return { kind: k, color: str(s.color) || CELL_RING_COLORS[k], width: num(s.width) > 0 ? num(s.width) : CELL_RING_WIDTH }
    }
    return null
}

// роль класса ячейки / строки для круга: 'bg' — фон ячейки остаётся (именованные полосы); сигнал кольца; 'marker' — треугольник-маркер остаётся; иначе null
const CLASS_ROLE = {
    'cell-lt': 'bg', 'cell-rc': 'bg',
    'alert-uncovered': 'uncovered', 'stock-critical': 'uncovered', 'grade-bad': 'uncovered', 'value-negative': 'uncovered',
    'stock-over-max': 'over-max', 'stock-excess': 'excess',
    'plan-manual': 'marker', 'wj-has-stack': 'marker',
}
export function cellRing_classRole(cls) {
    const c = str(cls)
    if (!c) return null
    if (Object.prototype.hasOwnProperty.call(CLASS_ROLE, c)) return CLASS_ROLE[c]
    if (c.startsWith('cell-background-')) return 'bg'
    return null
}
// классы ячейки и строки (_DLRow.cells[binding].cssClasses + _DLRow.cssClasses; массивы или строки через пробел) → сигналы колец без повторов
export function cellRing_signalsOf(...classLists) {
    const out = [], seen = new Set()
    for (const list of classLists) {
        const arr = Array.isArray(list) ? list : (typeof list === 'string' ? list.split(/\s+/) : [])
        for (const c of arr) {
            const r = cellRing_classRole(c)
            if (!r || r === 'bg' || r === 'marker' || seen.has(r)) continue
            seen.add(r)
            out.push({ kind: r })
        }
    }
    return out
}

// ---- сборка ---------------------------------------------------------------------------------------------------------------------------
// layers, scale, signals, size → { bg, diameter, dMax, ring, only, value, share, over } | null (нет положительных слоёв).
// opts: { value — значение для размера (иначе Σ положительных слоёв), legacy — прежний пирог: постоянный диаметр 13 px, без кольца;
// fill — p190: круг на всю высоту строки (cellChart_fillDiameter); rowMax — максимум строки: диаметр 60…100 % по √(v / rowMax) (cellChart_rowDiameter) }.
// opts.sizeValue — размер круга по другому значению, чем value (delta_prev_run: max(текущее, прошлое); delta_30d: max за 30 дней); диаметр — по sizeValue
// (не больше полного круга), а сигнал over-100 — только по value: шкала группы (cellRing_scale) считает max по значениям ячеек, и sizeValue больше max
// не даёт ложного красного кольца. IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T9)
// only — узкая колонка: ширина < 2 × dMax (числу места нет — только круг, число в подсказке)
export function cellRing_build(layers, scale, signals, size, opts = {}) {
    if (opts.concentric) return cellRing_buildConcentric(layers, scale, size, opts)   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p198 вид «Сигнали» — проблемні сигнали шарами кола, фон лише від lead time / циклу поповнення / зон запасу)
    const bg = cellRing_conic(layers)
    if (!bg) return null
    // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p211 контрастні кольори категорій і білий роздільник між секторами кіл): секторный круг с белыми разделителями — фон считается от итогового диаметра (opts.gaps — флаг fe.ux.pieSliceGaps); legacy — без них
    const bgOf = (d) => (opts.gaps && !opts.legacy ? cellRing_conic(layers, { gaps: true, diameter: d }) : bg)
    const sum = (Array.isArray(layers) ? layers : []).reduce((s, l) => s + Math.max(0, num(l && l.value)), 0)
    const value = (opts.value !== undefined && opts.value !== null && opts.value !== '' && Number.isFinite(Number(opts.value))) ? Number(opts.value) : sum
    const cellW = num(size && size.cellW)
    if (opts.legacy) {
        const d = CELL_RING_LEGACY_D
        return { bg, diameter: d, dMax: d, ring: null, only: cellW > 0 && cellW < 46, value, share: 0, over: false }
    }
    // IE 2026 11 01 / ODOO-350449 (заказ Игоря: статуси-крапка, зони запасів, виконання планів — T12): opts.fixedDiameter — круг постоянного диаметра
    // (status_dot: крапка 8 px рядом с числом) без шкалы: не больше места в ячейке, слот dMax = диаметр (число сразу за кругом), кольцо — по сигналам, без over-100
    const fixed = Number(opts.fixedDiameter)
    if (opts.fixedDiameter !== undefined && opts.fixedDiameter !== null && opts.fixedDiameter !== '' && Number.isFinite(fixed) && fixed > 0) {
        const room = cellRing_maxDiameter(size)
        const d = Math.round(room > 0 ? Math.min(fixed, room) : fixed)
        return { bg: bgOf(d), diameter: d, dMax: d, ring: cellRing_ring(signals), only: cellW > 0 && cellW < 2 * d, value, share: 0, over: false }   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p211 контрастні кольори категорій і білий роздільник між секторами кіл)
    }
    const hasSize = opts.sizeValue !== undefined && opts.sizeValue !== null && opts.sizeValue !== '' && Number.isFinite(Number(opts.sizeValue))   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T9)
    const dm = cellRing_diameter(hasSize ? Math.max(Math.abs(Number(opts.sizeValue)), Math.abs(value)) : value, scale, size)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T9)
    if (!(dm.diameter > 0)) return null
    if (hasSize) { const dv = cellRing_diameter(value, scale, size); dm.over = dv.over; dm.share = dv.share }   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T9): over-100 и доля — по value
    const sig = Array.isArray(signals) ? signals.slice() : []
    if (dm.over) sig.push({ kind: 'over-100' })
    const only = cellW > 0 && cellW < 2 * dm.dMax
    if (opts.fill) {   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 діаграми в клітинках — на всю висоту рядка, компактні й високі): круг на всю высоту строки, кольцо внутрь (inset) толщиной ∝ диаметру
        const dFill = cellChart_fillDiameter(size, dm.diameter, only)
        const rowMax = num(opts.rowMax)   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 — розмір кола від максимуму рядка, 60…100 %)
        const d = rowMax > 0 ? cellChart_rowDiameter(hasSize ? Math.max(Math.abs(Number(opts.sizeValue)), Math.abs(value)) : value, rowMax, dFill, size && size.cellH) : dFill
        const ring = cellRing_ring(sig)
        if (ring) { ring.width = cellChart_ringWidth(d); ring.inset = true }
        return { bg: bgOf(d), diameter: d, dMax: dFill, ring, only, value, share: dm.share, over: dm.over, fill: true, rowMax }   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 — розмір кола від максимуму рядка, 60…100 %): слот — dFill (числа в строке выровнены)
    }
    return { bg: bgOf(dm.diameter), diameter: dm.diameter, dMax: dm.dMax, ring: cellRing_ring(sig), only, value, share: dm.share, over: dm.over }   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p211 контрастні кольори категорій і білий роздільник між секторами кіл)
}

// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p198 вид «Сигнали» — проблемні сигнали шарами кола, фон лише від lead time / циклу поповнення / зон запасу)
// «слоёный» круг вида signals (opts.concentric): слои — сигналы (внешний первый), размер — по opts.value в шкале / по правилу p190 (fill, rowMax), как у
// обычного круга; кольца сигналов нет (сигналы — сами слои); проценты > 100 % — слой over-100 (после uncovered); значение 0 при сигнале — минимальный круг
// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p212 сигнал проблеми видно і в дочірніх рядках (порожня комірка), прив'язка дефіциту/попиту до міри руху): opts.fixedDiameter — круг постоянного диаметра (ячейка без значения)
export function cellRing_buildConcentric(layers, scale, size, opts = {}) {
    const ls = (Array.isArray(layers) ? layers : []).filter(l => num(l && l.value) > 0)
    if (!ls.length) return null
    const value = (opts.value !== undefined && opts.value !== null && opts.value !== '' && Number.isFinite(Number(opts.value))) ? Number(opts.value) : 0
    const cellW = num(size && size.cellW)
    const fixed = Number(opts.fixedDiameter)   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p212 сигнал проблеми видно і в дочірніх рядках (порожня комірка), прив'язка дефіциту/попиту до міри руху)
    if (!opts.legacy && opts.fixedDiameter !== undefined && opts.fixedDiameter !== null && opts.fixedDiameter !== '' && Number.isFinite(fixed) && fixed > 0) {   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p212 сигнал проблеми видно і в дочірніх рядках (порожня комірка), прив'язка дефіциту/попиту до міри руху)
        const room = cellRing_maxDiameter(size)
        const d = Math.round(room > 0 ? Math.min(fixed, room) : fixed)
        const bgF = cellRing_concentric(ls)
        return bgF ? { bg: bgF, diameter: d, dMax: d, ring: null, only: cellW > 0 && cellW < 2 * d, value, share: 0, over: false, layers: ls } : null   // ячейка без значения: круг постоянного диаметра, без over-100 и шкалы
    }
    if (opts.legacy) { const bg0 = cellRing_concentric(ls); return bg0 ? { bg: bg0, diameter: CELL_RING_LEGACY_D, dMax: CELL_RING_LEGACY_D, ring: null, only: cellW > 0 && cellW < 46, value, share: 0, over: false, layers: ls } : null }
    const dm = cellRing_diameter(value, scale, size)
    if (!(dm.diameter > 0)) {
        if (!(dm.dMax > 0)) return null
        dm.diameter = Math.min(CELL_RING_MIN_D, dm.dMax)
    }
    let all = ls
    if (dm.over && !ls.some(l => l.key === 'over-100')) {
        const at = ls.findIndex(l => l.key !== 'uncovered')
        const ov = { key: 'over-100', title: 'Over 100 %', value: 1, color: CELL_RING_COLORS['over-100'], tone: 'solid' }
        all = at < 0 ? [...ls, ov] : [...ls.slice(0, at), ov, ...ls.slice(at)]
    }
    const bg = cellRing_concentric(all)
    if (!bg) return null
    const only = cellW > 0 && cellW < 2 * dm.dMax
    if (opts.fill) {
        const dFill = cellChart_fillDiameter(size, dm.diameter, only)
        const rowMax = num(opts.rowMax)
        const d = rowMax > 0 ? cellChart_rowDiameter(value, rowMax, dFill, size && size.cellH) : dFill
        return { bg, diameter: d, dMax: dFill, ring: null, only, value, share: dm.share, over: dm.over, fill: true, rowMax, layers: all }
    }
    return { bg, diameter: dm.diameter, dMax: dm.dMax, ring: null, only, value, share: dm.share, over: dm.over, layers: all }
}
